export default 'Terms and Conditions'
